'use client'
import { MinifiedDynamicJwtFromJSON } from '@dynamic-labs/sdk-api-core';
import { logger } from '../../../logger.js';
import { parseToken } from '../parseToken/parseToken.js';

const decodeMinJwt = (token) => {
    try {
        const json = parseToken(token);
        if (!json)
            return undefined;
        return MinifiedDynamicJwtFromJSON(json);
    }
    catch (e) {
        logger.error(e);
        return undefined;
    }
};

export { decodeMinJwt };
